<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
defineProps({
  label: { type: String, default: 'Conversar com cliente' },
});

const emit = defineEmits(['open']);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <button
    type="button"
    class="flex min-w-0 w-full items-center gap-3 rounded-lais border border-lais-border bg-white px-3 py-3 text-left text-[13px] font-semibold text-lais-text hover:border-lais-primary hover:text-lais-primary"
    @click="emit('open')"
  >
    <span class="i-lucide-messages-square size-4 shrink-0" aria-hidden="true" />
    <span class="min-w-0 break-words">{{ label }}</span>
  </button>
</template>
